export const SN_PRISMIC = 'PRISMIC'
export const SET_PAGE = `${SN_PRISMIC}/SET_PAGE`
export const CLEAR_PAGES = `${SN_PRISMIC}/CLEAR_PAGES`
export const SET_BLOCK = `${SN_PRISMIC}/SET_BLOCK`
export const SET_ALTERNATE_LANGUAGE = `${SN_PRISMIC}/SET_ALTERNATE_LANGUAGE`
export const SET_TOTAL_RESULTS_SIZE = `${SN_PRISMIC}/SET_TOTAL_RESULTS_SIZE`
